<template>
  <div class="map-controls-right-wrapper right-column">
    <div class="map-controls-right-top-row">
      <map-controls-legend></map-controls-legend>
      <scale-toggle 
        :grayscale="grayscale" 
        :toggleScale="toggleScale">
        </scale-toggle>
        <download-button></download-button>
      </div>
      <map-year-nav :state="state"></map-year-nav>
      <map-controls-dates
      :riskData="riskData"></map-controls-dates>
  </div>
</template>

<script>
import MapControlsLegend from './MapControlsLegend';
import MapControlsYearNavigation from './MapControlsYearNavigation';
import MapControlsDates from './MapControlsDates';
import ScaleToggle from '../ScaleToggle';
import Download from '../Download';

export default {
  name: 'map-contorls-right',
  props: ['grayscale', 'toggleScale', 'state', 'riskData'],
  components: {
    'map-controls-legend': MapControlsLegend,
    'map-year-nav': MapControlsYearNavigation,
    'map-controls-dates': MapControlsDates,
    'scale-toggle': ScaleToggle,
    'download-button': Download,
  },
};
</script>

<style>
  .map-controls-right-wrapper {
    display: inline-block;
  }
  .map-controls-right-top-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
  }
</style>



// WEBPACK FOOTER //
// MapControlsRight.vue?45fdd85c